import Cookies from 'js-cookie';

export const axiosHeader = () => ({
  headers: {
    Authorization: Cookies.get(`customerToken`),
    Pragma: 'no-cache',
    tenant: getTenantId()
  }
});

export const axiosHeaderV2 = () => ({
  headers: {
    Authorization: Cookies.get(`customerToken`),
    Pragma: 'no-cache',
    tenantId: getTenantId(),
    tenant: getTenantId(),
    experimental: 'Do not use if you are not Commerce7.  API likely to change'
  }
});

export const publicAxiosHeaderV2 = () => {
  if (Cookies.get(`customerToken`)) {
    return axiosHeaderV2();
  }

  return {
    headers: {
      Pragma: 'no-cache',
      tenant: getTenantId(),
      tenantId: getTenantId(),
      experimental: 'Do not use if you are not Commerce7.  API likely to change'
    }
  };
};

export const publicAxiosHeader = () => {
  if (Cookies.get(`customerToken`)) {
    return axiosHeader();
  }
  return {
    headers: { Pragma: 'no-cache', tenant: getTenantId() }
  };
};

export const getV1RootUrl = () => {
  switch (process.env.APP_MODE) {
    case 'production':
      return 'https://api.commerce7.com/v1';
    case 'frontend':
      return 'https://api.commerce7.com/v1';
    default:
      return 'http://localhost:3000/v1';
  }
};

export const getV2OldRootUrl = () => {
  switch (process.env.APP_MODE) {
    case 'production':
      return 'https://api.commerce7.com/v1.1';
    case 'frontend':
      return 'https://api.commerce7.com/v1.1';
    default:
      return 'http://localhost:3000/v1.1';
  }
};

export const getV2RootUrl = () => {
  switch (process.env.APP_MODE) {
    case 'production':
      return 'https://api.commerce7.com/v2';
    case 'frontend':
      return 'https://api.commerce7.com/v2';
    default:
      return 'http://localhost:3002/v2';
  }
};

export const getTenantId = () => {
  const scriptTag = document.getElementById('c7-javascript');
  const tenantId = scriptTag.getAttribute('data-tenant');
  return tenantId;
};
